import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=5c5dc685&scoped=true&"
import script from "./BusinessProfile.vue?vue&type=script&lang=js&"
export * from "./BusinessProfile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProfile.vue?vue&type=style&index=0&id=5c5dc685&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dc685",
  null
  
)

export default component.exports